import React, { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet';
import '../css/schedule-fall.css';
import {
    fetchClasses,
    groupByDay,
    flagList,
    flagLabel,
    statusLabel,
    statusBadgeKind,
    formatTimeRange,
    formatAgeRange,
} from '../utils/scheduleData';
import { contentText, fetchContent } from '../utils/siteContent';
const SCHEDULE_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export default function Schedule2() {
    const [classes, setClasses] = useState(null);
    const [error, setError] = useState(null);
    const [content, setContent] = useState(null);

    useEffect(() => {
        let cancelled = false;
        fetchClasses('fall')
            .then((data) => { if (!cancelled) setClasses(data); })
            .catch((err) => { if (!cancelled) setError(err.message); });
        fetchContent().then((data) => { if (!cancelled) setContent(data); });
        return () => { cancelled = true; };
    }, []);

    const byDay = classes ? groupByDay(classes) : null;
    const scheduleRows = useMemo(() => {
        if (!byDay) return null;
        return SCHEDULE_DAYS.reduce((schedule, day) => {
            const rows = {};
            (byDay[day] || []).forEach((cls) => {
                const room = String(cls.Room || cls.room || '').trim();
                if (room !== '1' && room !== '2') return;
                if (!rows[cls._startMin]) rows[cls._startMin] = { room1: [], room2: [] };
                rows[cls._startMin][room === '1' ? 'room1' : 'room2'].push(cls);
            });
            schedule[day] = Object.entries(rows)
                .sort(([a], [b]) => Number(a) - Number(b))
                .map(([, row]) => row);
            return schedule;
        }, {});
    }, [byDay]);

    return (
        <div className="fallSchedule-content">
            <Helmet>
                <title>In Motion Dance | Schedule</title>
            </Helmet>

            <h1>{contentText(content, 'schedule_title', 'Fall/Spring Schedule')}</h1>
            <p className="fallSchedule-subtitle">{contentText(content, 'schedule_date_range', 'Sept 8, 2026 – June 11, 2027')}</p>
            {content && content.schedule_updated && (
                <p className="fallSchedule-updated">Updated: {content.schedule_updated}</p>
            )}

            {error && (
                <p className="fallSchedule-error">
                    We couldn't load the current schedule ({error}). Please refresh, or contact
                    the studio if this keeps happening.
                </p>
            )}

            {!error && !classes && (
                <p className="fallSchedule-loading">Loading the schedule…</p>
            )}

            {scheduleRows && (
                <div className="fallSchedule-grid">
                    {SCHEDULE_DAYS.map((day) => (
                        <div className="fallSchedule-day" key={day}>
                            <h2>{day}</h2>
                            <div className="fallSchedule-rooms">
                                <div className="fallSchedule-roomHeaders"><h3>Room 1</h3><h3>Room 2</h3></div>
                                <div className="fallSchedule-timeRows">
                                    {scheduleRows[day].map((row, index) => {
                                        const startsAt1230 = [...row.room1, ...row.room2]
                                            .some((cls) => String(cls.start_time).trim() === '12:30 PM');
                                        return (
                                        <div className={`fallSchedule-timeRow ${startsAt1230 ? 'fallSchedule-afternoonBreak' : ''}`} key={`${day}-${index}`}>
                                            <div className="fallSchedule-roomSlot">
                                                {row.room1.map((cls) => (
                                                <article className="classCard" key={`${cls.class_id}-${day}-1`}>
                                                <div className="classCard-time">{formatTimeRange(cls)}</div>
                                                <div className="classCard-name">{cls.name}</div>
                                                <div className="classCard-meta">
                                                    <span className="classCard-age">{formatAgeRange(cls)}</span>
                                                    {cls.instructor && <span className="classCard-instructor">{cls.instructor}</span>}
                                                </div>
                                                {statusBadgeKind(cls.status) || flagList(cls.flags).length > 0 ? (
                                                    <div className="classCard-badges">
                                                        {statusBadgeKind(cls.status) && (
                                                            <span className={`badge badge-status-${statusBadgeKind(cls.status)}`}>
                                                                {statusLabel(cls.status)}
                                                            </span>
                                                        )}
                                                        {flagList(cls.flags).map((flag) => (
                                                            <span className="badge badge-flag" key={flag}>{flagLabel(flag)}</span>
                                                        ))}
                                                    </div>
                                                ) : null}
                                                </article>
                                                ))}
                                            </div>
                                            <div className="fallSchedule-roomSlot">
                                                {row.room2.map((cls) => (
                                                <article className="classCard" key={`${cls.class_id}-${day}-2`}>
                                                <div className="classCard-time">{formatTimeRange(cls)}</div>
                                                <div className="classCard-name">{cls.name}</div>
                                                <div className="classCard-meta">
                                                    <span className="classCard-age">{formatAgeRange(cls)}</span>
                                                    {cls.instructor && <span className="classCard-instructor">{cls.instructor}</span>}
                                                </div>
                                                {statusBadgeKind(cls.status) || flagList(cls.flags).length > 0 ? (
                                                    <div className="classCard-badges">
                                                        {statusBadgeKind(cls.status) && <span className={`badge badge-status-${statusBadgeKind(cls.status)}`}>{statusLabel(cls.status)}</span>}
                                                        {flagList(cls.flags).map((flag) => <span className="badge badge-flag" key={flag}>{flagLabel(flag)}</span>)}
                                                    </div>
                                                ) : null}
                                                </article>
                                                ))}
                                            </div>
                                        </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}
